import React from "react";

export const HorizontalBarChart12 = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={44} height={28} rx={1} fill="#F1F2F6" />

    <g
      stroke="#8E97A9"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1={4} y1={4} x2={40} y2={4} />
      <line x1={4} y1={9} x2={32} y2={9} />
      <line x1={4} y1={14} x2={20} y2={14} />
      <line x1={4} y1={19} x2={40} y2={19} />
      <line x1={4} y1={24} x2={35} y2={24} />
    </g>
  </g>
);
